<fieldset [formGroup]="discrepancyLogGroup" *ngIf="visible$ | async">
    <div class="mb-3">
        <label class="col-form-label" for="{{ (discrepancyLog$ | async)?.xmlId }}">{{
            (discrepancyLog$ | async)?.label
        }}</label>
        <textarea
            class="col form-control input-md text-input"
            cols="100"
            rows="4"
            [formControl]="inputFieldControl"
            id="{{ (discrepancyLog$ | async)?.xmlId }}"
        ></textarea>
    </div>
    <div *ngIf="(discrepancyLog$ | async)?.controllingCheckpoint.length === 0" class="mb-3 not-applicable">
        <div class="checkbox-container">
            <input
                type="checkbox"
                class="form-control"
                id="discrepancy-log-not-applicable"
                #checkbox
                [formControl]="checkboxControl"
            />
            <fa-icon *ngIf="checkbox.checked" [icon]="faCheck" size="2x" (click)="checkbox.click()"></fa-icon>
        </div>
        <label translate="F4M_NOT_APPLICABLE_LABEL" for="discrepancy-log-not-applicable"></label>
    </div>
</fieldset>
